//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { Paper } from '@mui/material'
import { useOtChainState } from '@react/redux/store'
import { REPORT_FETCH_DESCRIPTOR_TRANSACTION_LIST } from '@react/reporting/ReportDescriptors'
import ReportRowGenerator from '@react/reporting/ReportRowGenerator'
import { ZeroAddress } from 'ethers'
import React, { ReactElement } from 'react'

export default function LenderTransactionPage(): ReactElement {
  const {
    userConnection: { accountAddr },
  } = useOtChainState()
  return (
    <React.Fragment>
      <Paper sx={{ padding: 4, margin: 2, borderRadius: 4 }}>
        <ReportRowGenerator
          reportDescriptor={REPORT_FETCH_DESCRIPTOR_TRANSACTION_LIST}
          initialLoadWithoutRefresh={true}
          poolAddr={ZeroAddress}
          lenderAddr={accountAddr}
          numberOfDays={30}
        />
      </Paper>
    </React.Fragment>
  )
}
